module.exports = __webpack_public_path__ + "static/IMG_7882-3c75bf4bc36a420d2da2e0ebe5dc3b9e.jpg";